const EmbeddingType = {
  Dashboard: 'Dashboard',
  Library: 'Library',
  Visualization: 'Visualization',
  Bot: 'Bot',
  Bot_Api: 'Bot_Api',
  Bot_Auto: 'Bot_Auto',
  Bot_AutoImage: 'Bot_AutoImage',
  NextGet_AI: 'NextGet_AI',

  getFilterTapType(embeddingType) {
    const mapping = {
      [EmbeddingType.Bot_Api]: EmbeddingType.Bot,
      [EmbeddingType.Bot_Auto]: EmbeddingType.Bot,
      [EmbeddingType.Bot_AutoImage]: EmbeddingType.Bot,
      [EmbeddingType.NextGet_AI]: EmbeddingType.Bot,
    };
    return mapping[embeddingType] || embeddingType;
  },
};

export default EmbeddingType;
